"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketClientConnector = exports.connectivityMethodToWebsocketUrl = void 0;
const NodeWebsocketClientConnection_1 = require("./NodeWebsocketClientConnection");
const IConnection_1 = require("../IConnection");
const WebsocketClientConnectorRpcLocal_1 = require("./WebsocketClientConnectorRpcLocal");
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const Handshaker_1 = require("../Handshaker");
const Connectivity_1 = require("../../helpers/Connectivity");
const identifiers_1 = require("../../identifiers");
const PendingConnection_1 = require("../PendingConnection");
const connectivityMethodToWebsocketUrl = (ws, action) => {
    return (ws.tls ? 'wss://' : 'ws://') + ws.host + ':' + ws.port + ((action !== undefined) ? '?action=' + action : '');
};
exports.connectivityMethodToWebsocketUrl = connectivityMethodToWebsocketUrl;
class WebsocketClientConnector {
    static WEBSOCKET_CONNECTOR_SERVICE_ID = 'system/websocket-connector';
    websocketServer;
    geoIpLocator;
    localPeerDescriptor;
    connectingConnections = new Map();
    abortController = new AbortController();
    options;
    constructor(options) {
        this.options = options;
        this.registerLocalRpcMethods();
    }
    registerLocalRpcMethods() {
        const rpcLocal = new WebsocketClientConnectorRpcLocal_1.WebsocketClientConnectorRpcLocal({
            connect: (targetPeerDescriptor) => this.connect(targetPeerDescriptor),
            hasConnection: (nodeId) => (this.connectingConnections.has(nodeId)
                || this.options.hasConnection(nodeId)),
            onNewConnection: (connection) => this.options.onNewConnection(connection),
            abortSignal: this.abortController.signal
        });
        this.options.rpcCommunicator.registerRpcNotification(DhtRpc_1.WebsocketConnectionRequest, 'requestConnection', async (req, context) => {
            if (!this.abortController.signal.aborted) {
                return rpcLocal.requestConnection(req, context);
            }
            else {
                return {};
            }
        });
    }
    isPossibleToFormConnection(targetPeerDescriptor) {
        const connectionType = (0, Connectivity_1.expectedConnectionType)(this.localPeerDescriptor, targetPeerDescriptor);
        return connectionType === IConnection_1.ConnectionType.WEBSOCKET_CLIENT;
    }
    connect(targetPeerDescriptor) {
        const nodeId = (0, identifiers_1.toNodeId)(targetPeerDescriptor);
        const existingConnection = this.connectingConnections.get(nodeId);
        if (existingConnection) {
            return existingConnection;
        }
        const socket = new NodeWebsocketClientConnection_1.WebsocketClientConnection();
        const url = (0, exports.connectivityMethodToWebsocketUrl)(targetPeerDescriptor.websocket);
        const pendingConnection = new PendingConnection_1.PendingConnection(targetPeerDescriptor);
        (0, Handshaker_1.createOutgoingHandshaker)(this.localPeerDescriptor, pendingConnection, socket, targetPeerDescriptor);
        this.connectingConnections.set(nodeId, pendingConnection);
        const delFunc = () => {
            if (this.connectingConnections.has(nodeId)) {
                this.connectingConnections.delete(nodeId);
            }
            socket.off('disconnected', delFunc);
            pendingConnection.off('disconnected', delFunc);
            pendingConnection.off('connected', delFunc);
        };
        socket.on('disconnected', delFunc);
        pendingConnection.on('disconnected', delFunc);
        pendingConnection.on('connected', delFunc);
        socket.connect(url, false);
        return pendingConnection;
    }
    setLocalPeerDescriptor(peerDescriptor) {
        this.localPeerDescriptor = peerDescriptor;
    }
    async destroy() {
        this.abortController.abort();
        const requests = Array.from(this.connectingConnections.values());
        await Promise.allSettled(requests.map((conn) => conn.close(true)));
        await this.websocketServer?.stop();
        this.geoIpLocator?.stop();
    }
}
exports.WebsocketClientConnector = WebsocketClientConnector;
//# sourceMappingURL=WebsocketClientConnector.js.map